module.exports = __webpack_public_path__ + "img/logo-icon.58a6da84.png";